import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Logo } from "./Extras";
import { NAV_LINKS } from "../data/content";

const Header = ({ base = "" }) => {
    const [open, setOpen] = useState(false);

    return (
        <header data-testid="site-header" className="sticky top-0 z-40 bg-brand-ink shadow-soft">
            <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
                <Logo variant="filled" />
                <nav className="hidden items-center gap-7 lg:flex" aria-label="Navegación principal">
                    {NAV_LINKS.map((l) => (
                        <a
                            key={l.href}
                            data-testid={`nav-${l.href.slice(1)}`}
                            href={`${base}${l.href}`}
                            className="text-sm font-semibold text-white/85 transition-colors duration-200 hover:text-white"
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>
                <button
                    data-testid="mobile-menu-toggle"
                    onClick={() => setOpen(!open)}
                    aria-label={open ? "Cerrar menú" : "Abrir menú"}
                    aria-expanded={open}
                    className="flex h-11 w-11 items-center justify-center rounded-full text-white lg:hidden"
                >
                    {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
                </button>
            </div>
            {open && (
                <nav
                    data-testid="mobile-menu"
                    className="border-t border-white/15 bg-brand-ink px-4 pb-5 pt-2 lg:hidden"
                    aria-label="Navegación móvil"
                >
                    {NAV_LINKS.map((l) => (
                        <a
                            key={l.href}
                            data-testid={`mobile-nav-${l.href.slice(1)}`}
                            href={`${base}${l.href}`}
                            onClick={() => setOpen(false)}
                            className="block rounded-xl px-3 py-3 text-base font-semibold text-white/90 transition-colors duration-200 hover:bg-white/10"
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>
            )}
        </header>
    );
};

export default Header;
